export default {
    knowledge: {
        title: 'Conhecimento',
        subtitle: 'Aprenda sobre temas como Astrologia, tarot e relacionamento'
    },

    header: {
        goodMorning: 'Bom dia, {userName}!',
        goodAfternoon: 'Boa tarde, {userName}!',
        goodEvening: 'Boa noite, {userName}!',
        shareButton: 'Compartilhar'
    },

    birthChart: {
        sun: 'Sol',
        rising: 'Ascendente',
        moon: 'Lua',
        linkText: 'VER MEU MAPA ASTRAL',
        noRisingMessage: 'Informe seu <strong>horário de nascimento</strong>'
    },

    dailyAdvice: {
        title: 'Conselho diário',
        subtitle: 'Novas reflexões para você, todos os dias!',
        buttonText: 'MAIS JOGOS DE TAROT',
        revealCard: 'REVELAR CARTA'
    },

    moonCycle: {
        title: 'Ciclo Lunar',
        buttonText: 'VEJA TODAS AS DICAS'
    },

    whatsappWidget: {
        title: 'Receba previsões e benefícios direto no seu WhatsApp',
        description: 'Cadastre seu celular e seja notificado sobre trânsitos importantes, promoções e conteúdos exclusivos!',
        inputLabel: 'Telefone celular (Com DDD)',
        submitButton: 'Quero receber!',
        disclaimer: 'Ao informar seu número, você autoriza o envio de mensagens do Astrolink pelo WhatsApp. Cancele a qualquer momento.',
        successMessage: 'Obrigado! Em breve você receberá novidades no WhatsApp.',
        errorMessage: 'Erro ao salvar seu número. Tente novamente.'
    },

    aiChat: {
        title: 'Assistente Astrológico',
        message: 'Quer entender seu mapa? Te ajudo com isso e muito mais!',
        buttonText: 'CONVERSE COM O ORBIA'
    },

    skyMoment: {
        title: 'O Céu Agora'
    },

    synastry: {
        title: 'Compatibilidades',
        buttonNewMap: 'NOVO MAPA',
        linkViewMap: 'VER MAPA',
        buttonViewCompatibility: 'VEJA A COMPATIBILIDADE',
        viewMoreMaps: 'Ver mais mapas',
        influencesLabel: 'INFLUENCIAS\nATIVAS',
        linkViewInfluences: 'VER INFLUENCIAS',
        emptyExtraCharts: {
            message: 'Você pode criar o mapa astral de qualquer pessoa, ver sua compatibilidade e horóscopo!',
            buttonText: 'CRIE UM MAPA EXTRA'
        },
        scoreTitle: {
            explicitDifferences: 'Diferenças explícitas',
            noticeableDifferences: 'Diferenças perceptíveis',
            basicHarmony: 'Harmonia básica',
            goodHarmony: 'Boa harmonia astral!',
            veryGoodHarmony: 'Harmonia astral muito boa!',
            greatHarmony: 'Ótima Harmonia astral!',
            excellentHarmony: 'Harmonia astral excelente!'
        }
    },

    tools: {
        title: 'Mais ferramentas',
        dreams: 'Interpretação de <strong>Sonhos</strong>',
        orbia: '<strong style="line-height: 0.7">Assistente</strong> Astrologia + IA / Orbia',
        biorhythm: '<strong style="margin-bottom: -7px">Biorritmo</strong> Ciclos do corpo e mente',
        loveMap: 'Análise Astrológica <strong style="font-size: 22px">Mapa do Amor</strong>',
        guide: 'Previsões e Artigos <strong>Guia 2026</strong>',
        articles: '<strong style="font-size: 22px; line-height: 0.7">Artigos</strong> Explore e aprenda',
        lunarNodes: '<strong style="font-size: 22px; margin-bottom: -7px">Missão de Alma</strong> Seu nodos lunares',
        journal: '<strong style="font-size: 22px; margin-bottom: -7px">Diário Pessoal</strong> Sobre seu dia e o céu',
        celebrities: '<strong style="font-size: 22px; margin-bottom: -7px">Famosos</strong> Mapa dos seus ídolos'
    },

    summarizedHoroscope: {
        title: 'Horóscopo Personalizado',
        subtitle: 'Acompanhe suas influências diárias e saiba como o céu do momento interage com seu mapa astral.',
        accessMessage: {
            prefix: 'Acesse o ',
            link: 'Horóscopo Resumido',
            suffix: ' e veja a síntese dos trânsitos astrológicos ativos, focada em cada área da vida: relacionamentos, família, dinheiro, saúde e mais.'
        },
        tipsTitle: 'Dicas de hoje',
        buttonText: 'HORÓSCOPO COMPLETO',
        infoCards: {
            active: 'Ativas',
            future: 'Futuras',
            mainTransit: 'Principal do dia'
        },
        areas: {
            love: 'Amor',
            career: 'Carreira',
            family: 'Família',
            health: 'Saúde'
        }
    },

    errorState: {
        message: 'Nosso observatório está em manutenção! Tente novamente ou aguarde alguns minutos',
        buttonText: 'TENTAR NOVAMENTE'
    },

    offlineState: {
        message: 'Sua conexão parece fora de órbita! Conecte-se à internet e tente novamente',
        buttonText: 'TENTAR NOVAMENTE'
    },

    errorMessage: {
        maintenance: 'Nosso observatório está em manutenção\nTente novamente em alguns minutos'
    },

    frustationButton: {
        default: 'Habilitar Recursos <span>Premium</span>',
        htmlWithCompletition: '<span>QUERO SER PREMIUM <br /> <span>Conheça os beneficios</span></span>'
    }
};
